const glassStyles = `
:root {
    --search-overlay: rgb(26 26 26 / 18%);
    --search-glass: rgb(255 255 255 / 74%);
    --search-border: rgb(255 255 255 / 72%);
    --search-ink: #1a1a1a;
    --search-muted: #635f5c;
    --search-hover: rgb(255 255 255 / 42%);
    color-scheme: light;
}
:root[data-theme="dark"] {
    --search-overlay: rgb(0 0 0 / 38%);
    --search-glass: rgb(31 31 29 / 78%);
    --search-border: rgb(255 255 255 / 14%);
    --search-ink: #eceae6;
    --search-muted: #b6b2ab;
    --search-hover: rgb(255 255 255 / 8%);
    color-scheme: dark;
}
html, body { background: transparent !important; color: var(--search-ink); }
body > div:first-child {
    background: var(--search-overlay) !important;
    background-image: none !important;
    -webkit-backdrop-filter: blur(18px) saturate(120%) !important;
    backdrop-filter: blur(18px) saturate(120%) !important;
}
.h-screen > .bg-white {
    overflow: hidden;
    border: 1px solid var(--search-border);
    background: var(--search-glass) !important;
    box-shadow: 0 24px 64px rgb(0 0 0 / 20%) !important;
    -webkit-backdrop-filter: blur(28px) saturate(145%);
    backdrop-filter: blur(28px) saturate(145%);
}
.h-screen > .bg-white > .bg-white { background: transparent !important; box-shadow: none !important; }
.h-screen > .bg-white:has(> div:nth-child(2)) > div:first-child { border-bottom: 1px solid var(--search-border); }
input { min-width: 0; background: transparent !important; color: var(--search-ink) !important; }
input::placeholder { color: var(--search-muted) !important; }
[class*="text-neutral"] { color: var(--search-muted) !important; }
svg.text-neutral-900, a { color: var(--search-ink) !important; }
a:hover { background: var(--search-hover); }
body > div:first-child, .h-screen > .bg-white, .h-screen > .bg-white > .bg-white {
    transition: background-color 350ms ease-in-out, border-color 350ms ease-in-out, color 350ms ease-in-out;
}
`;

export default function searchOverlay() {
    const styleId = 'tiwb-search-glass';
    const root = document.documentElement;
    const boundFrames = new WeakSet();
    // Sodo binds a persistent hidden trigger once, including direct article loads.
    document.addEventListener('click', event => {
        if (event.defaultPrevented || !event.target.closest('[data-search-trigger]')) return;
        event.preventDefault();
        document.querySelector('[data-search-proxy]')?.click();
    });

    function apply(frame) {
        try {
            const document = frame.contentDocument;
            if (!document?.head) return;
            let style = document.getElementById(styleId);
            if (!style) {
                style = document.createElement('style');
                style.id = styleId;
                style.textContent = glassStyles;
                document.head.append(style);
            }
            document.documentElement.dataset.theme = root.dataset.theme || 'light';
        } catch (_) {}
    }

    function refresh() {
        document.querySelectorAll('#sodo-search-root iframe').forEach(frame => {
            if (!boundFrames.has(frame)) {
                boundFrames.add(frame);
                frame.addEventListener('load', () => apply(frame), {once: true});
            }
            apply(frame);
        });
    }

    new MutationObserver(refresh).observe(document.body, {childList: true, subtree: true});
    new MutationObserver(refresh).observe(root, {attributes: true, attributeFilter: ['data-theme']});
    refresh();
}
